import { Heart, PawPrint } from "lucide-react";
import { WIN_AMBUSHES, WIN_AFFECTION } from "../muskiData";

export default function AffectionMeter({ affection, ambushes }) {
  const pct = Math.max(0, Math.min(100, affection));
  const barColor =
    pct >= 85 ? "from-emerald-400 to-sky-400" : pct >= 40 ? "from-sky-400 to-indigo-400" : "from-pink-500 to-rose-400";

  return (
    <div className="glass rounded-3xl p-5 sm:p-6" data-testid="affection-panel">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-lg font-bold flex items-center gap-2">
          <Heart className="h-5 w-5 text-pink-400" fill="currentColor" /> Affection
        </h3>
        <span data-testid="affection-value" className="font-mono-ui text-sm text-sky-300">
          {pct}%
        </span>
      </div>

      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-slate-800/80 border border-white/5" data-testid="affection-meter">
        <div
          className={`h-full rounded-full bg-gradient-to-r ${barColor}`}
          style={{ width: `${pct}%`, transition: "width 0.5s cubic-bezier(.22,1,.36,1)" }}
        />
      </div>

      <div className="mt-2 flex justify-between font-mono-ui text-[10px] uppercase tracking-widest text-slate-500">
        <span>Annoyed</span>
        <span className={pct >= 60 ? "text-emerald-300" : ""}>Purr Zone</span>
        <span className={pct >= WIN_AFFECTION ? "text-amber-300" : ""}>Engine ❤</span>
      </div>

      {/* ambush survival */}
      <div className="mt-5 flex items-center justify-between rounded-2xl bg-slate-900/60 border border-white/5 p-3">
        <div>
          <p className="font-mono-ui text-[10px] uppercase tracking-widest text-slate-500">Ambushes survived</p>
          <p className="font-display text-base font-bold text-slate-100">Survive the Rug Trap x{WIN_AMBUSHES}</p>
        </div>
        <div className="flex gap-1.5" data-testid="ambush-tracker">
          {Array.from({ length: WIN_AMBUSHES }).map((_, i) => (
            <PawPrint
              key={i}
              className={`h-6 w-6 ${i < ambushes ? "text-amber-400" : "text-slate-700"}`}
              fill={i < ambushes ? "currentColor" : "none"}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
